// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.auth-modal {
  background: #1a1a1a;
  border-radius: 3px;
  padding: 40px;
  width: 90%;
  max-width: 420px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8);
  position: relative;
  animation: slideIn 0.3s ease-out;
  border: 1px solid #333;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.auth-modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  color: #999;
  font-size: 28px;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  transition: all 0.2s;
}

.auth-modal-close:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.auth-modal h2 {
  margin: 0 0 8px 0;
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
}

.auth-modal-subtitle {
  margin: 0 0 24px 0;
  color: #999;
  font-size: 14px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  color: #ccc;
  font-size: 14px;
  font-weight: 500;
}

.form-group input {
  width: 100%;
  padding: 12px;
  background: #2a2a2a;
  border: 1px solid #3a3a3a;
  border-radius: 3px;
  color: #fff;
  font-size: 14px;
  transition: all 0.2s;
  box-sizing: border-box;
}

.form-group input:focus {
  outline: none;
  border-color: #4a9eff;
  background: #2f2f2f;
}

.form-group input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.form-group input::placeholder {
  color: #666;
}

.auth-error {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #ef4444;
  padding: 12px;
  border-radius: 3px;
  margin-bottom: 16px;
  font-size: 14px;
}

.auth-submit-btn {
  width: 100%;
  padding: 12px;
  background: #4a9eff;
  border: none;
  border-radius: 3px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.auth-submit-btn:hover:not(:disabled) {
  background: #3a8eef;
  transform: translateY(-1px);
}

.auth-submit-btn:active:not(:disabled) {
  transform: translateY(0);
}

.auth-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.auth-switch {
  margin-top: 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
}

.auth-switch-btn {
  background: none;
  border: none;
  color: #4a9eff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  padding: 0;
  text-decoration: underline;
}

.auth-switch-btn:hover {
  color: #3a8eef;
}`, "",{"version":3,"sources":["webpack://./src/components/auth/AuthModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".auth-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n.auth-modal {\n  background: #1a1a1a;\n  border-radius: 3px;\n  padding: 40px;\n  width: 90%;\n  max-width: 420px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8);\n  position: relative;\n  animation: slideIn 0.3s ease-out;\n  border: 1px solid #333;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.auth-modal-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: none;\n  border: none;\n  color: #999;\n  font-size: 28px;\n  cursor: pointer;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 3px;\n  transition: all 0.2s;\n}\n\n.auth-modal-close:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n.auth-modal h2 {\n  margin: 0 0 8px 0;\n  color: #fff;\n  font-size: 24px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.auth-modal-subtitle {\n  margin: 0 0 24px 0;\n  color: #999;\n  font-size: 14px;\n}\n\n.form-group {\n  margin-bottom: 16px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 6px;\n  color: #ccc;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 12px;\n  background: #2a2a2a;\n  border: 1px solid #3a3a3a;\n  border-radius: 3px;\n  color: #fff;\n  font-size: 14px;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #4a9eff;\n  background: #2f2f2f;\n}\n\n.form-group input:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.form-group input::placeholder {\n  color: #666;\n}\n\n.auth-error {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #ef4444;\n  padding: 12px;\n  border-radius: 3px;\n  margin-bottom: 16px;\n  font-size: 14px;\n}\n\n.auth-submit-btn {\n  width: 100%;\n  padding: 12px;\n  background: #4a9eff;\n  border: none;\n  border-radius: 3px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.auth-submit-btn:hover:not(:disabled) {\n  background: #3a8eef;\n  transform: translateY(-1px);\n}\n\n.auth-submit-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.auth-submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.auth-switch {\n  margin-top: 20px;\n  text-align: center;\n  color: #999;\n  font-size: 14px;\n}\n\n.auth-switch-btn {\n  background: none;\n  border: none;\n  color: #4a9eff;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 0;\n  text-decoration: underline;\n}\n\n.auth-switch-btn:hover {\n  color: #3a8eef;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
